import React from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../../stores/store";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import { useSubmitData } from "../../../../hooks/useSubmitData";
import * as yup from "yup";
import { useSetMenu } from "../../../../hooks/useSetMenu";
import FormLayout from '../../../Generic/FormLayout';
import FormInput from '../../../Generic/FormInput';
import FormCheckbox from '../../../Generic/FormCheckbox';

const Add = () => {
  const { mainStore } = useStore();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  useSetMenu(mainStore.KeyFeaturesAdminMenuType, mainStore.KeyFeaturesAdminMenuNo);

  const onError = (errors, e) =>
    enqueueSnackbar(t("onErrorSubmit"), { variant: "error" });

  const schema = yup.object({
    titleEN: yup.string().required(t('requiredField')).max(200, t('maxLength', { max: 200 })),
    featureOrder: yup.number().required(t('requiredField')).min(1, t('minValue', { min: 1 })),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      featureOrder: 1,
      isVisible: true,
    }
  });

  const sendData = useSubmitData(axiosPrivate, "/KeyFeatures", "/Admin/KeyFeatures");
  const onSubmit = data => sendData(data);
  const onCancel = () => navigate(-1);

  return (
    <FormLayout title={t("keyFeatureCreateTitle") || "Add Key Feature"} onSubmit={handleSubmit(onSubmit, onError)} onCancel={onCancel}>
      <FormInput label="order" name="featureOrder" type="number" register={register} errors={errors} colSize={2} />
      <FormInput label="iconClass" name="iconClass" register={register} errors={errors} colSize={4} />
      <FormInput label="iconBgColor" name="iconBgColor" register={register} errors={errors} colSize={3} />
      <FormInput label="iconColor" name="iconColor" register={register} errors={errors} colSize={3} />
      <FormInput label="titleEN" name="titleEN" register={register} errors={errors} colSize={12} />
      <FormInput label="titleBG" name="titleBG" register={register} errors={errors} colSize={6} />
      <FormInput label="titleSQ" name="titleSQ" register={register} errors={errors} colSize={6} />
      <FormInput label="descriptionEN" name="descriptionEN" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormInput label="descriptionBG" name="descriptionBG" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormInput label="descriptionSQ" name="descriptionSQ" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormCheckbox label="isVisible" register={register} name="isVisible" colSize={4} />
    </FormLayout>
  );
};

export default Add;
